module.exports = __webpack_public_path__ + "img/light.57ed254e.svg";